var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "main-container box" }, [
        _c("div", { staticClass: "couponBox" }, [
          _c(
            "h5",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOk,
                  expression: "isOk"
                }
              ]
            },
            [
              _c("img", {
                staticClass: "dImg",
                attrs: { src: _vm.diconImg, alt: "" }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.template.couponSimpleName
                      ? _vm.template.couponSimpleName
                      : _vm.template.couponName
                  )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOk && String(_vm.template.couponType) === "5",
                  expression: "isOk && String(template.couponType) === '5'"
                }
              ],
              staticClass: "price"
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.template.faceAmount || 0))]),
              _vm._v("\n                    折\n                ")
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOk && String(_vm.template.couponType) !== "5",
                  expression: "isOk && String(template.couponType) !== '5'"
                }
              ],
              staticClass: "price"
            },
            [
              _vm._v("\n                    ￥"),
              _c("span", [_vm._v(_vm._s(_vm.template.faceAmount))])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOk,
                  expression: "isOk"
                }
              ],
              staticClass: "time"
            },
            [
              _c("p", { staticClass: "timeTitle" }, [
                _vm._v("满" + _vm._s(_vm.template.thresholdAmount) + "使用")
              ]),
              _vm._v(" "),
              _vm.template.couponValidityType !== "1"
                ? _c("p", { staticClass: "timeContent" }, [
                    _vm._v(
                      "有效时间 " +
                        _vm._s(_vm.template.couponValidityStart) +
                        " - " +
                        _vm._s(_vm.template.couponValidityEnd)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.template.couponValidityType === "1"
                ? _c("p", { staticClass: "timeContent" }, [
                    _vm._v(
                      "有效时间 领取后" +
                        _vm._s(_vm.template.couponValidityDay) +
                        "天"
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ljBox" },
          [
            _c(
              "van-button",
              {
                staticClass: "ljBtn",
                attrs: {
                  round: "",
                  type: "danger",
                  disabled:
                    _vm.template.couponTemplateProgress !== "进行中" ||
                    _vm.template.status !== "1"
                },
                on: {
                  click: function($event) {
                    _vm.couponOk(_vm.template)
                  }
                }
              },
              [_vm._v("立即领券")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }